import {InputText} from 'primereact/inputtext';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import MenuItemIcon from '../MenuItemIcon';
import BaseInputComponent from './BaseInputComponent';

class InputTextComponent extends BaseInputComponent {
    renderView() {
        const {
            colClass,
            formGroup,
            iconColor,
            iconName,
            iconSide,
            iconSize,
            iconSvg,
            id,
            insideTable,
            label,
            objectId,
            publicMode,
            renderValue,
            renderLabel,
            renderRequired,
            showLabel,
            titleElement,
            titleElementClass,
            titleElementShowId,
            value,
            validateViewMode,
            validator,
            validators,
        } = this.props;
        const required = validators !== undefined && validators.includes('required') && !validators.includes('not_required');
        return (
            <div className={insideTable ? '' : titleElement ? titleElementClass : colClass}>
                <div className={insideTable ? '' : 'row'}>
                    <div className={insideTable ? '' : `col-md-12 ${formGroup ? 'form-group' : ''}`}>
                        {this.baseRenderLabel(id, label, showLabel, titleElement, renderRequired && required, renderLabel)}
                        <span
                            id={`${id}-view-value`}
                            aria-label={label}
                            aria-labelledby={`${id}-label-id`}
                            className={`p-inputtext-view icon_text ${titleElement ? ' title-element' : ''} ${
                                iconName !== undefined ? iconColor : ''
                            }`}
                        >
                            {iconSide === 'left' && iconName !== undefined ? <i className={`icon mdi ${iconName} ${iconSize}`} /> : null}
                            {iconSide === 'left' && iconSvg !== undefined ? (
                                <MenuItemIcon alt='' className={`icon-svg ${iconSize}`} iconSvg={iconSvg} />
                            ) : null}
                            {renderValue ? renderValue(value) : value}
                            {iconSide === 'right' && iconName !== undefined ? <i className={`icon mdi ${iconName} ${iconSize}`} /> : null}
                            
                        </span>
                        {titleElement && titleElementShowId ? <span className='p-inputtext-view'>{` ID: ${objectId}`}</span> : null}
                        {validateViewMode && validator ? validator.message(id, label, value, validators) : null}
                    </div>
                </div>
            </div>
        );
    }

    renderEdit() {
        return this.renderNew();
    }

    renderNew() {
        const {
            colClass,
            disabled,
            id,
            insideTable,
            keyfilter,
            label,
            max,
            name,
            onAfterStateChange,
            onChange,
            placeholder,
            publicMode,
            showLabel,
            stateField,
            tooltip,
            validator,
            validators,
            value,
            renderLabel,
            renderRequired,
            onBlur,
            iconColor,
            iconName,
            iconSide,
            iconSize,
            forceUpperCase,
            iconSvg,
            onInput,
            forcePrefixRegEx,
            partialPrefixRegEx,
            defaultPrefix,
            format,
            style
        } = this.props;
        const required = validators !== undefined && validators.includes('required') && !validators.includes('not_required');
        return (
            <div className={insideTable ? '' : colClass}>
                <div className={insideTable ? 'row' : 'row'}>
                    <div className={insideTable ? '' : 'col-md-12 form-group'}>
                        {this.baseRenderLabel(id, label, showLabel, undefined, renderRequired && required, renderLabel)}
                        <span className={`p-inputtext-view icon_text  ${iconName !== undefined ? iconColor : ''}`}>
                            {iconSide === 'left' && iconName !== undefined ? <i className={`icon mdi ${iconName} ${iconSize}`} /> : null}
                            {iconSide === 'left' && iconSvg !== undefined ? (
                                <MenuItemIcon alt='' className={`icon-svg ${iconSize}`} iconSvg={iconSvg} />
                            ) : null}

                            {iconSide === 'right' && iconName !== undefined ? <i className={`icon mdi ${iconName} ${iconSize}`} /> : null}
                        </span>
                        <InputText                            
                            aria-describedby={`${id}-error`}
                            aria-label={label}
                            aria-labelledby={label === undefined && showLabel ? `${id}-label-id` : undefined}
                            key={id}
                            id={id}
                            name={name}
                            maxLength={max}
                            type='text'
                            keyfilter={keyfilter}
                            placeholder={placeholder}
                            style={style ? style : {width: '100%', textAlign: format == 'number' ? 'right' : ''}}
                            value={value}
                            onChange={(e) =>
                                onChange
                                    ? onChange(
                                          'TEXT',
                                          [forceUpperCase, forcePrefixRegEx, partialPrefixRegEx, defaultPrefix],
                                          e,
                                          onAfterStateChange,
                                          stateField
                                      )
                                    : null
                            }
                            onBlur={onBlur}
                            disabled={disabled}
                            required={required}
                            tooltip={tooltip}
                            onInput={onInput}
                            autoComplete='off'
                        />
                        <div aria-live='assertive'>{validator ? validator.message(id, label, value, validators) : null}</div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {rendered, viewMode} = this.props;
        if (rendered) {
            switch (viewMode) {
                case 'NEW':
                    return this.renderNew();
                case 'EDIT':
                    return this.renderEdit();
                case 'VIEW':
                default:
                    return this.renderView();
            }
        } else {
            return null;
        }
    }
}

InputTextComponent.defaultProps = {
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',
    disabled: false,
    format: 'string',
    formGroup: true,    
    iconSide: 'left',
    insideTable: false,
    max: 255,    
    objectId: '',
    placeholder: '',
    publicMode: false,
    rendered: true,
    renderRequired: false,
    showLabel: true,
    stateField: 'element',
    titleElement: false,
    titleElementShowId: false,
    titleElementClass: 'col-md-12',
    validateViewMode: false,
    forceUpperCase: false,
    validators: 'required',
    viewMode: 'VIEW',
};

InputTextComponent.propTypes = {
    colClass: PropTypes.string,
    disabled: PropTypes.bool,
    formGroup: PropTypes.bool,
    iconColor: PropTypes.string,
    iconName: PropTypes.string,
    iconSide: PropTypes.string,
    iconSize: PropTypes.string,
    iconSvg: PropTypes.string,
    id: PropTypes.string.isRequired,
    insideTable: PropTypes.bool,
    keyfilter: PropTypes.instanceOf(RegExp),
    label: PropTypes.string.isRequired,
    max: PropTypes.number,
    name: PropTypes.string.isRequired,
    objectId: PropTypes.string,
    onAfterStateChange: PropTypes.func,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    publicMode: PropTypes.bool,
    rendered: PropTypes.bool,
    showLabel: PropTypes.bool,
    stateField: PropTypes.string,
    titleElement: PropTypes.bool,
    titleElementClass: PropTypes.string,
    titleElementShowId: PropTypes.bool,
    validateViewMode: PropTypes.bool,
    validator: PropTypes.object,
    validators: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewMode: PropTypes.string,
    renderLabel: PropTypes.func,
    renderRequired: PropTypes.bool,
    forceUpperCase: PropTypes.bool,
    forcePrefixRegEx: PropTypes.instanceOf(RegExp),
    partialPrefixRegEx: PropTypes.instanceOf(RegExp),
    defaultPrefix: PropTypes.string,
    onBlur: PropTypes.func,
    format: PropTypes.string,
};

export default withTranslation()(InputTextComponent);
